import { render } from "./PlaceHolder.vue?vue&type=template&id=a7cd2256&scoped=true"
import script from "./PlaceHolder.vue?vue&type=script&lang=js"
export * from "./PlaceHolder.vue?vue&type=script&lang=js"

import "./PlaceHolder.vue?vue&type=style&index=0&id=a7cd2256&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7cd2256"]])

export default __exports__